import { getToken } from '@/lib/token';
import { handlerRedirectUrlByLimitOpt } from '../lib/utils';
import { getUserInfo, getUserInfoByAuthCode } from '@/lib/auth';
import { updateRouter, hasUpdatedRouter } from './index';

const PUBLIC_ROUTE_NAMES = ['LOGIN', 'LOGINOLD', 'PHONE_LOGIN', 'LOGINV2'];

const initRouter = (router) => {
  if (!router) return;

  router.beforeEach(async (to, from, next) => {
    try {
      if (to.query.limitOpt) {
        sessionStorage.setItem('limitOpt', to.query.limitOpt);
      }
      if (to.query.linghitScope) {
        sessionStorage.setItem('linghitScope', to.query.linghitScope);
      }

      const limitOpt = sessionStorage.getItem('limitOpt');
      const linghitScope = sessionStorage.getItem('linghitScope');

      // linghitScope为userinfo时，且链接带有authCode和app_id参数时，表示用户已授权，直接进入获取用户信息流程，跳过登录。(避免抢占登录)
      if (limitOpt && linghitScope === 'userinfo' && to.query.authCode && to.query.app_id) {
        const userInfo = await getUserInfoByAuthCode({
          code: to.query.authCode,
          app_id: to.query.app_id,
        });
        await handlerRedirectUrlByLimitOpt({ limitOpt, userInfo });
        sessionStorage.removeItem('limitOpt');
        sessionStorage.removeItem('linghitScope');
        return next(false);
      }

      if (!getToken()) {
        if (!PUBLIC_ROUTE_NAMES.includes(to.name)) {
          return next('/loginV2');
        }
        return next();
      }

      const userInfo = await getUserInfo();

      if (limitOpt) {
        await handlerRedirectUrlByLimitOpt({ limitOpt, userInfo });
        sessionStorage.removeItem('limitOpt');
        return next(false);
      }

      if (!hasUpdatedRouter) {
        updateRouter(userInfo);
        return next({
          path: to.path,
          query: to.query,
          hash: to.hash,
          replace: true,
        });
      }

      // /v2 已废弃，统一回到首页
      if (to.path === '/v2') {
        return next({ path: '/', replace: true });
      }

      return next();
    } catch (err) {
      console.error('[router] beforeEach error:', err);
      return next('/loginV2');
    }
  });
};

export default initRouter;
